import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { capitalizeFirstLetter } from '../utils/functions';

export default function CatsHome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { username } = user
  
  useEffect(() => {
    const { role } = user;

    switch (role) {
      case 'admin':
        navigate('/cats/admin');
        break;
      case 'merchant':
        navigate('/cats/merchant');
        break;
      case 'user':
        navigate('/cats/merchant');
        break;
      default:
        navigate('/auth');
        break;
    }
  }, [user, navigate]);

  return <h1>{`Welcome to CATS${username ? `, ${capitalizeFirstLetter(username)}` : ''}!`}</h1>
}
